var mediastar_receiver = {
    name: "mediastar",
    defaultCommandIndex: 1,
    commands: [
        {
            function: "KEY_POWER",
            name: "KEY_POWER",
            icon: "KEY_POWER",
            command: [71,0,6,140,2,209,1,142,2,69,6,207,35,92,17,141,2,158,159,186,35,111,8,146,2,0,0,59,245,170,237,246,213,68,32,128],
        },
        {
            function: "KEY_MUTE",
            name: "KEY_MUTE",
            icon: "KEY_MUTE",
            command: [71,0,6,141,2,209,1,143,2,66,6,182,35,88,17,166,2,162,159,182,35,114,8,142,2,0,0,59,245,170,221,125,117,68,32,128],
        },
        {
            function: "DISPLAY",
            name: "DISPLAY",
            icon: "DISPLAY",
            command: [71,0,6,141,2,208,1,141,2,66,6,203,35,77,17,138,2,142,159,177,35,116,8,135,2,0,0,59,245,170,255,106,171,68,32,128],
        },
        {
            function: "KEY_MODE",
            name: "KEY_MODE",
            icon: "KEY_MODE",
            command: [71,0,6,140,2,210,1,144,2,63,6,171,35,74,17,148,2,141,159,172,35,101,8,148,2,0,0,59,245,170,223,186,171,68,32,128],
        },
        {
            function: "TIMER",
            name: "TIMER",
            icon: "TIMER",
            command: [71,0,6,139,2,209,1,147,2,63,6,174,35,80,17,140,2,121,159,197,35,114,8,137,2,0,0,59,245,170,239,182,171,68,32,128],
        },
        {
            // function: "TV/R",
            function: "KEY_SOURCE",
            name: "KEY_SOURCE",
            icon: "KEY_SOURCE",
            command: [71,0,6,141,2,206,1,145,2,64,6,163,35,84,17,144,2,148,159,168,35,75,8,174,2,0,0,59,245,170,245,122,245,68,32,128],
        },
        {
            function: "KEY_1",
            name: "KEY_1",
            icon: "KEY_1",
            command: [71,0,6,145,2,202,1,145,2,66,6,172,35,87,17,143,2,150,159,171,35,105,8,148,2,0,0,59,245,170,223,245,85,68,32,128],
        },
        {
            function: "KEY_2",
            name: "KEY_2",
            icon: "KEY_2",
            command: [71,0,6,142,2,210,1,143,2,63,6,197,35,72,17,150,2,138,159,174,35,108,8,144,2,0,0,59,245,170,239,237,85,68,32,128],
        },
        {
            function: "KEY_3",
            name: "KEY_3",
            icon: "KEY_3",
            command: [71,0,6,140,2,209,1,143,2,63,6,172,35,81,17,143,2,125,159,178,35,78,8,169,2,0,0,59,245,170,215,253,85,68,32,128],
        },
        {
            function: "KEY_4",
            name: "KEY_4",
            icon: "KEY_4",
            command: [71,0,6,146,2,210,1,139,2,65,6,180,35,84,17,142,2,145,159,172,35,111,8,145,2,0,0,59,245,170,247,235,85,68,32,128],
        },
        {
            function: "KEY_5",
            name: "KEY_5",
            icon: "KEY_5",
            command: [71,0,6,140,2,209,1,146,2,64,6,180,35,85,17,147,2,146,159,176,35,118,8,137,2,0,0,59,245,170,219,251,85,68,32,128],
        },
        {
            function: "KEY_6",
            name: "KEY_6",
            icon: "KEY_6",
            command: [71,0,6,148,2,205,1,149,2,57,6,215,35,73,17,150,2,127,159,192,35,113,8,139,2,0,0,59,245,170,235,247,85,68,32,128],
        },
        {
            function: "KEY_7",
            name: "KEY_7",
            icon: "KEY_7",
            command: [71,0,6,141,2,211,1,141,2,65,6,173,35,85,17,142,2,136,159,176,35,117,8,137,2,0,0,59,245,170,213,255,85,68,32,128],
        },
        {
            function: "KEY_8",
            name: "KEY_8",
            icon: "KEY_8",
            command: [71,0,6,143,2,209,1,136,2,67,6,194,35,81,17,147,2,142,159,171,35,107,8,145,2,0,0,59,245,170,251,234,213,68,32,128],
        },
        {
            function: "KEY_9",
            name: "KEY_9",
            icon: "KEY_9",
            command: [71,0,6,140,2,215,1,139,2,63,6,175,35,79,17,180,2,143,159,171,35,105,8,149,2,0,0,59,245,170,221,250,213,68,32,128],
        },
        {
            function: "KEY_0",
            name: "KEY_0",
            icon: "KEY_0",
            command: [71,0,6,140,2,210,1,144,2,65,6,177,35,73,17,147,2,148,159,178,35,105,8,150,2,0,0,59,245,170,255,213,85,68,32,128],
        },
        {
            function: "SAT",
            name: "SAT",
            icon: "SAT",
            command: [71,0,6,140,2,209,1,144,2,63,6,196,35,85,17,144,2,136,159,177,35,111,8,143,2,0,0,59,245,170,238,246,181,68,32,128],
        },
        {
            function: "F1",
            name: "F1",
            icon: "F1",
            command: [71,0,6,141,2,213,1,146,2,59,6,183,35,82,17,144,2,135,159,175,35,108,8,143,2,0,0,59,245,170,218,190,245,68,32,128],
        },
        {
            function: "RECALL",
            name: "RECALL",
            icon: "RECALL",
            command: [71,0,6,145,2,210,1,139,2,64,6,173,35,75,17,137,2,149,159,177,35,100,8,154,2,0,0,59,245,170,214,183,187,68,32,128],
        },
        {
            function: "ZOOM",
            name: "ZOOM",
            icon: "ZOOM",
            command: [71,0,6,139,2,209,1,145,2,64,6,181,35,80,17,166,2,115,159,214,35,113,8,141,2,0,0,59,245,170,219,221,171,68,32,128],
        },
        {
            function: "MOTOR",
            name: "MOTOR",
            icon: "MOTOR",
            command: [71,0,6,141,2,214,1,142,2,62,6,177,35,78,17,148,2,157,159,170,35,113,8,141,2,0,0,59,245,170,251,181,107,68,32,128],
        },
        {
            function: "TXT",
            name: "TXT",
            icon: "TXT",
            command: [71,0,6,144,2,211,1,137,2,67,6,172,35,50,17,142,2,152,159,173,35,112,8,143,2,0,0,59,245,170,247,181,171,68,32,128],
        },
        {
            function: "FIND",
            name: "FIND",
            icon: "FIND",
            command: [71,0,6,139,2,212,1,140,2,65,6,179,35,75,17,135,2,145,159,179,35,116,8,137,2,0,0,59,245,170,253,181,91,68,32,128],
        },
        {
            function: "EPG",
            name: "EPG",
            icon: "EPG",
            command: [71,0,6,141,2,209,1,145,2,66,6,174,35,80,17,139,2,153,159,178,35,116,8,139,2,0,0,59,245,170,213,191,181,68,32,128],
        },
        {
            function: "PAUSE",
            name: "PAUSE",
            icon: "PAUSE",
            command: [71,0,6,139,2,212,1,140,2,67,6,182,35,85,17,137,2,151,159,173,35,110,8,144,2,0,0,59,245,170,235,187,173,68,32,128],
        },
        {
            function: "SLEEP",
            name: "SLEEP",
            icon: "SLEEP",
            command: [71,0,6,140,2,213,1,138,2,67,6,172,35,47,17,151,2,143,159,169,35,117,8,139,2,0,0,59,245,170,215,111,91,68,32,128],
        },
        {
            function: "AUDIO (RED)",
            name: "AUDIO (RED)",
            icon: "AUDIO (RED)",
            command: [71,0,6,140,2,208,1,142,2,69,6,180,35,79,17,149,2,139,159,172,35,105,8,150,2,0,0,59,245,170,222,221,91,68,32,128],
        },
        {
            function: "NET (GREEN)",
            name: "NET (GREEN)",
            icon: "NET (GREEN)",
            command: [71,0,6,140,2,209,1,144,2,62,6,174,35,74,17,171,2,140,159,175,35,113,8,137,2,0,0,59,245,170,238,219,91,68,32,128],
        },
        {
            function: "WIFI (YELLOW)",
            name: "WIFI (YELLOW)",
            icon: "WIFI (YELLOW)",
            command: [71,0,6,143,2,207,1,145,2,62,6,176,35,80,17,143,2,145,159,185,35,107,8,144,2,0,0,59,245,170,219,110,219,68,32,128],
        },
        {
            function: "INFO (BLUE)",
            name: "INFO (BLUE)",
            icon: "INFO (BLUE)",
            command: [71,0,6,144,2,209,1,142,2,62,6,182,35,55,17,145,2,141,159,174,35,102,8,148,2,0,0,59,245,170,235,109,219,68,32,128],
        },
        {
            function: "FAV",
            name: "FAV",
            icon: "FAV",
            command: [71,0,6,142,2,210,1,141,2,65,6,173,35,78,17,142,2,114,159,204,35,107,8,149,2,0,0,59,245,170,246,245,181,68,32,128],
        },
        {
            function: "SUB",
            name: "SUB",
            icon: "SUB",
            command: [71,0,6,137,2,213,1,141,2,67,6,180,35,84,17,141,2,144,159,173,35,121,8,135,2,0,0,59,245,170,250,218,187,68,32,128],
        },
        {
            function: "KEY_UP",
            name: "KEY_UP",
            icon: "KEY_UP",
            command: [71,0,6,136,2,211,1,133,2,77,6,181,35,85,17,131,2,136,159,182,35,118,8,135,2,0,0,59,245,170,214,254,213,68,32,128],
        },
        {
            function: "KEY_LEFT",
            name: "KEY_LEFT",
            icon: "KEY_LEFT",
            command: [71,0,6,141,2,210,1,139,2,63,6,165,35,84,17,139,2,151,159,168,35,100,8,150,2,0,0,59,245,170,213,127,213,68,32,128],
        },
        {
            function: "KEY_DOWN",
            name: "KEY_DOWN",
            icon: "KEY_DOWN",
            command: [71,0,6,136,2,208,1,130,2,83,6,166,35,82,17,128,2,152,159,168,35,111,8,147,2,0,0,59,245,170,234,251,213,68,32,128],
        },
        {
            function: "KEY_RIGHT",
            name: "KEY_RIGHT",
            icon: "KEY_RIGHT",
            command: [71,0,6,138,2,206,1,134,2,78,6,171,35,76,17,126,2,123,159,170,35,105,8,145,2,0,0,59,245,170,245,245,213,68,32,128],
        },
        {
            function: "KEY_OK",
            name: "KEY_OK",
            icon: "KEY_OK",
            command: [71,0,6,145,2,208,1,145,2,58,6,183,35,64,17,151,2,109,159,211,35,99,8,146,2,0,0,59,245,170,218,253,213,68,32,128],
        },
        {
            function: "MENU",
            name: "MENU",
            icon: "MENU",
            command: [71,0,6,144,2,208,1,143,2,63,6,176,35,74,17,138,2,144,159,168,35,110,8,142,2,0,0,59,245,170,235,123,181,68,32,128],
        },
        {
            function: "EXIT",
            name: "EXIT",
            icon: "EXIT",
            command: [71,0,6,144,2,207,1,142,2,63,6,173,35,82,17,140,2,143,159,174,35,104,8,147,2,0,0,59,245,170,213,95,245,68,32,128],
        },
        {
            function: "KEY_VOLUMEUP",
            name: "KEY_VOLUMEUP",
            icon: "KEY_VOLUMEUP",
            command: [71,0,6,136,2,210,1,136,2,72,6,180,35,81,17,145,2,142,159,172,35,112,8,138,2,0,0,59,245,170,254,234,173,68,32,128],
        },
        {
            function: "KEY_VOLUMEDOWN",
            name: "KEY_VOLUMEDOWN",
            icon: "KEY_VOLUMEDOWN",
            command: [71,0,6,136,2,208,1,131,2,83,6,205,35,83,17,127,2,132,159,173,35,121,8,132,2,0,0,59,245,170,223,122,173,68,32,128],
        },
        {
            function: "page(ch) up",
            name: "page(ch) up",
            icon: "page(ch) up",
            command: [71,0,6,138,2,208,1,138,2,65,6,172,35,80,17,140,2,132,159,172,35,108,8,140,2,0,0,59,245,170,246,218,219,68,32,128],
        },
        {
            function: "page(ch) down",
            name: "page(ch) down",
            icon: "page(ch) down",
            command: [71,0,6,131,2,207,1,136,2,82,6,186,35,70,17,125,2,124,159,172,35,109,8,141,2,0,0,59,245,170,213,183,219,68,32,128],
        },
        {
            function: "HD",
            name: "HD",
            icon: "HD",
            command: [71,0,6,140,2,211,1,137,2,70,6,177,35,79,17,144,2,145,159,174,35,118,8,133,2,0,0,59,245,170,215,222,171,68,32,128],
        },
        {
            function: "USB",
            name: "USB",
            icon: "USB",
            command: [71,0,6,140,2,210,1,145,2,63,6,177,35,83,17,145,2,147,159,177,35,106,8,146,2,0,0,59,245,170,214,239,107,68,32,128],
        },
        {
            function: "record fast backward (rewind)",
            name: "record fast backward (rewind)",
            icon: "record fast backward (rewind)",
            command: [71,0,6,138,2,205,1,130,2,85,6,175,35,86,17,124,2,158,159,172,35,118,8,136,2,0,0,59,245,170,253,234,181,68,32,128],
        },
        {
            function: "record fast forward",
            name: "record fast forward",
            icon: "record fast forward",
            command: [71,0,6,132,2,208,1,131,2,86,6,167,35,84,17,126,2,136,159,168,35,110,8,143,2,0,0,59,245,170,219,125,181,68,32,128],
        },
        {
            function: "record Previous; to play previous part",
            name: "record Previous; to play previous part",
            icon: "record Previous; to play previous part",
            command: [71,0,6,135,2,208,1,133,2,82,6,171,35,72,17,129,2,145,159,164,35,128,8,131,2,0,0,59,245,170,222,250,181,68,32,128],
        },
        {
            function: "record Next; to play next part",
            name: "record Next; to play next part",
            icon: "record Next; to play next part",
            command: [71,0,6,139,2,202,1,132,2,82,6,167,35,73,17,126,2,118,159,178,35,116,8,138,2,0,0,59,245,170,214,191,117,68,32,128],
        },
        {
            function: "record play",
            name: "record play",
            icon: "record play",
            command: [71,0,6,137,2,202,1,135,2,85,6,176,35,81,17,126,2,154,159,169,35,107,8,148,2,0,0,59,245,170,235,219,171,68,32,128],
        },
        {
            function: "record pause",
            name: "record pause",
            icon: "record pause",
            command: [71,0,6,139,2,201,1,137,2,81,6,176,35,78,17,128,2,146,159,163,35,121,8,136,2,0,0,59,245,170,237,123,117,68,32,128],
        },
        {
            function: "record stop",
            name: "record stop",
            icon: "record stop",
            command: [71,0,6,137,2,205,1,133,2,81,6,168,35,78,17,123,2,134,159,170,35,111,8,139,2,0,0,59,245,170,234,189,245,68,32,128],
        },
        {
            function: "record record",
            name: "record record",
            icon: "record record",
            command: [71,0,6,136,2,207,1,132,2,82,6,200,35,70,17,126,2,116,159,173,35,102,8,148,2,0,0,59,245,170,215,126,181,68,32,128],
        },
        {
            function: "record F2",
            name: "record F2",
            icon: "record F2",
            command: [71,0,6,132,2,201,1,140,2,87,6,199,35,89,17,128,2,148,159,175,35,113,8,140,2,0,0,59,245,170,239,118,173,68,32,128],
        },
        {
            function: "record F3",
            name: "record F3",
            icon: "record F3",
            command: [71,0,6,136,2,210,1,136,2,75,6,180,35,82,17,137,2,132,159,173,35,111,8,141,2,0,0,59,245,170,215,190,173,68,32,128],
        },
        {
            function: "record F4",
            name: "record F4",
            icon: "record F4",
            command: [71,0,6,130,2,206,1,134,2,84,6,169,35,76,17,127,2,133,159,164,35,114,8,138,2,0,0,59,245,170,247,117,173,68,32,128],
        },
        {
            function: "record F5",
            name: "record F5",
            icon: "record F5",
            command: [71,0,6,139,2,206,1,141,2,66,6,173,35,71,17,148,2,126,159,172,35,110,8,138,2,0,0,59,245,170,219,189,173,68,32,128],
        },
    ]
}
export default mediastar_receiver